<template>
  <div>
    <div class="row">
      <div class="col">
        <h4>Shipping Address</h4>
        <div class="form-group">
          <label for="inputShippingFirstName">Shipping Name:</label>
          <div class="d-flex">
            <input
              id="inputShippingFirstName"
              v-model="customer.first_name"
              type="text"
              class="form-control mr-1"
              placeholder="First name"
            >
            <input
              id="inputShippingLastName"
              v-model="customer.last_name"
              type="text"
              class="form-control"
              placeholder="Last name"
            >
          </div>
        </div>
        <div class="form-group">
          <label for="inputShippingAddress">Shipping Address:</label>
          <input
            id="inputShippingAddress"
            v-model="customer.address"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputShippingCity">Shipping City:</label>
          <input
            id="inputShippingCity"
            v-model="customer.city"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputShippingSate">Shipping State:</label>
          <input
            id="inputShippingSate"
            v-model="customer.region"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputShippingZip">Shipping Zip:</label>
          <input
            id="inputShippingZip"
            v-model="customer.zip"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputShippingCountry">Shipping Country:</label>
          <input
            id="inputShippingCountry"
            v-model="customer.country"
            disabled
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
      <div class="col">
        <h4>Billing Address</h4>
        <div class="form-group">
          <label for="inputShippingBillingFirstName">Billing Name:</label>
          <div class="d-flex">
            <input
              id="inputShippingBillingFirstName"
              v-model="customer.billing_first_name"
              type="text"
              class="form-control mr-1"
              placeholder="First name"
            >
            <input
              id="inputShippingBillingLastName"
              v-model="customer.billing_last_name"
              type="text"
              class="form-control"
              placeholder="Last name"
            >
          </div>
        </div>
        <div class="form-group">
          <label for="inputBillingAddress">Billing Address:</label>
          <input
            id="inputBillingAddress"
            v-model="customer.billing_address"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputBillingCity">Billing City:</label>
          <input
            id="inputBillingCity"
            v-model="customer.billing_city"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputBillingSate">Billing State:</label>
          <input
            id="inputBillingSate"
            v-model="customer.billing_region"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputBillingZip">Billing Zip:</label>
          <input
            id="inputBillingZip"
            v-model="customer.billing_zip"
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
        <div class="form-group">
          <label for="inputBillingCountry">Billing Country:</label>
          <input
            id="inputBillingCountry"
            v-model="customer.billing_country"
            disabled
            type="text"
            class="form-control"
            placeholder=""
          >
        </div>
      </div>
    </div>
    <hr>
    <button
      class="btn btn-success float-right"
      @click="save"
    >
      Save
    </button>
    <button
      class="btn btn-light float-right mr-3"
      @click="hiddenModal"
    >
      Close
    </button>
  </div>
</template>

<script>
    export default {
        name: "OrderEditCustomer",
        props: ['customer'],
        methods: {
            hiddenModal: function () {
                this.$root.$emit('bv::hide::modal', 'refEditCustomer')
            },
            save: function () {
                let post = this.customer
                let vm = this
                this.$http.post(this.$config.api + 'order/customer', post).then(function () {
                    //   this.$emit('update', vm.customer)
                    vm.$root.$emit('bv::hide::modal', 'refEditCustomer')
                })
            }
        }
    }
</script>

<style scoped>

</style>